// QR-Deep-Link vom Pairing (displaydeck.app/verbinden?code=XXXXXX).
// Rendert die Bildschirme-Ansicht -- screens.vue oeffnet bei ?code= den Verbinden-Dialog.
const route = {
    path: '/verbinden',
    meta: { authClass: 'protected' },
    components: {
        default:
            () => import(/* webpackChunkName: "screens" */ '../../components/views/screens/screens.vue'),
    },
};

module.exports = route;
